import type { SalesChecklistItemDefaultExample } from "@expert/contentful";

import { useDetectedCuesStore, useProductOfferStore } from "@expert/sales-tools";

import type { ChecklistItemExample } from "@/sales-tools/home-product/components/FullOfferChecklist/components/carousels/ChecklistItemExampleCarousel";

import { CarouselWithDefault } from "@/sales-tools/home-product/components/FullOfferChecklist/components/carousels/CarouselWithDefault";
import { getDetectedDeviceExamples } from "@/sales-tools/home-product/components/FullOfferChecklist/utils/getDetectedDeviceExamples";
import { useLanguageStore } from "@/sales-tools/language-selector/useLanguageStore";
import { useSessionId } from "@/sdk";

interface CoverageCarouselProps {
    defaultExample: SalesChecklistItemDefaultExample;
    staticExamples?: string[];
}

export function CoverageCarousel({ defaultExample, staticExamples }: CoverageCarouselProps) {
    const { getPrimaryProducts, getProductInfo } = useProductOfferStore.getState();
    const sessionId = useSessionId();
    const devices = useDetectedCuesStore((state) => state.getDisplayCues(sessionId));
    const primaryProductSku = getPrimaryProducts(sessionId).at(0)?.productSku;
    const languageState = useLanguageStore();
    const coverageResponses =
        getProductInfo(sessionId, primaryProductSku, languageState.language)?.personalizedCoverage ?? [];
    const detectedExamples = getDetectedDeviceExamples(devices, coverageResponses);

    const staticItems: ChecklistItemExample[] = (staticExamples ?? []).map((text) => ({ text }));
    const examples = [...staticItems, ...detectedExamples];

    return <CarouselWithDefault defaultExample={defaultExample} examples={examples} />;
}
